import { EditFilled, EyeFilled } from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";
import DataTable from "components/molecules/DataTable";
import ProhibitedArea from "components/molecules/ProhibitedArea";
import moment from "moment";
import CypressTestIds from "../../../cypress/CypressTestIds";

const SchemaModelRecentList = ({ permission, schemaModelList, onViewSchemaModel, onEditSchemaModel }) => {
    return !permission ? (
        <ProhibitedArea></ProhibitedArea>
    ) : (
        <DataTable
            dataTestId={CypressTestIds.RECENT_LIST_SCHEMA_TABLE}
            hideSelectionColumn={true}
            tableProps={{
                size: "small",
                rowKey: "schemaId",
                sticky: true,
                dataSource: schemaModelList,
                pagination: false,
                columns: [
                    {
                        width: "4rem",
                        fixed: "left",
                        render: (value, schema, index) => (
                            <Space.Compact size="small" className="gap-1">
                                <Tooltip title="Edit Schema">
                                    <Button
                                        type="text"
                                        icon={<EditFilled style={{ color: "#2185d0" }} />}
                                        disabled={!permission.canEdit}
                                        onClick={(event) => {
                                            event && event.stopPropagation && event.stopPropagation();
                                            onEditSchemaModel(schema);
                                        }}
                                        data-testid={CypressTestIds.RECENT_LIST_SCHEMA_EDIT_BUTTON}
                                    />
                                </Tooltip>
                                <Tooltip title="View Schema">
                                    <Button
                                        type="text"
                                        icon={<EyeFilled style={{ color: "#2185d0" }} />}
                                        disabled={!permission.canView}
                                        onClick={(event) => {
                                            event && event.stopPropagation && event.stopPropagation();
                                            onViewSchemaModel(schema);
                                        }}
                                        data-testid={CypressTestIds.RECENT_LIST_SCHEMA_VIEW_BUTTON}
                                    />
                                </Tooltip>
                            </Space.Compact>
                        ),
                    },
                    {
                        dataIndex: "name",
                        title: "Schema",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, schema, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        dataIndex: "description",
                        title: "Description",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, schema, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        dataIndex: "businessAreaName",
                        title: "Business Area",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, schema, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        dataIndex: "updatedDate",
                        title: "Last Updated",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, schema, index) => {
                            let dateValue = moment.utc(value).toDate().toLocaleString();
                            return (
                                <Tooltip placement="topLeft" title={dateValue}>
                                    {dateValue}
                                </Tooltip>
                            );
                        },
                    },
                    {
                        dataIndex: "updatedByEmail",
                        title: "Updated By",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, schema, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                ],
            }}
        />
    );
};

export default SchemaModelRecentList;
